// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"20":"sandbox","243":"lesson","631":"lessonintro","796":"coursedashboard","960":"changepassword"}[chunkId] + "." + {"20":"a98b59b8","243":"7724b24a","631":"d8166123","796":"5f73b50e","960":"68e61057"}[chunkId] + ".js";
};